import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Dialog, Button, Select } from "@activecollab/components";
import PropTypes from "prop-types";
import { getActiveUsers } from "../../../store/selectors/selector.users.jsx";
import { useConversationContext } from "../context/index.jsx";

export const ConversationInviteForm = ({ onSubmit, onCancel }) => {
  const { conversation, invite } = useConversationContext();
  const { t } = useTranslation();
  let { members } = conversation ?? {};
  members = members ?? [];
  const [userIds, setUserIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const users = useSelector(getActiveUsers);

  const options = useMemo(() => {
    return users
      .filter((user) => members.indexOf(user.id) === -1)
      .map((user) => ({
        id: user.id,
        name: user.display_name,
        image: user.avatar_url,
      }))
      .toArray();
  }, [members, users]);

  const handleSubmit = useCallback(async () => {
    if (userIds.length > 0 && typeof invite === "function") {
      setLoading(true);
      await invite(userIds);
      setLoading(false);
      typeof onSubmit === "function" && onSubmit();
    }
  }, [onSubmit, userIds, invite]);

  const handleChange = useCallback((newUserIds) => {
    setUserIds(newUserIds);
  }, []);

  return (
    <>
      <Dialog.Title>{t("Invite to conversation")}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content className="conversation_invite_content">
        <Select
          selected={userIds}
          options={options}
          type="multiple"
          onChange={handleChange}
          target={undefined}
          placeholder={t("Search people")}
        />
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions>
        <Button
          type="button"
          onClick={handleSubmit}
          disabled={userIds.length === 0 || loading}
          variant="primary"
          className="tw-mr-3"
        >
          {t("Invite")}
        </Button>
        <Button
          type="button"
          onClick={onCancel}
          variant="secondary"
          disabled={loading}
        >
          {t("Cancel")}
        </Button>
      </Dialog.Actions>
    </>
  );
};

ConversationInviteForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};
